import styled from "styled-components";

export const InvoiceTableContainer = styled.div`
  overflow-y: auto;
  table {
    thead {
      border-bottom: 1px solid #ececee;
      tr {
        background: #fcfcfc;
        border: 1px solid #ececee;
        th {
          /* padding-block: 20px; */
          color: #000000;
          font-size: clamp(12px, 0.833vw, 16px);
          font-family: "latosemibold";
          padding: clamp(15px, 1.042vw, 20px);
          white-space: nowrap;
          border: none;
          text-align: left;
        }
      }
    }
    tbody {
      border: 1px solid #ececee;
      .even-rows {
        background: #fcfcfc;
      }
      .odd-rows {
        background: #fff;
      }
      .set-border {
        border: 1px solid #ececee;
        border-bottom: 0;
      }
      tr {
        border: none;
        td {
          padding: clamp(15px, 1.042vw, 20px);
          font-size: clamp(10px, 0.729vw, 14px);
          font-family: "latoregular";
          border: 0;
          text-align: left;

          /* :first-child {
            font-family: "latosemibold";
          } */
          .tag {
            border-radius: clamp(10px, 1.042vw, 20px);
            height: clamp(20px, 1.563vw, 30px);
            box-shadow: none;
            font-size: clamp(10px, 0.729vw, 14px);
            font-family: "Latoregular";
            text-transform: capitalize;
          }
          .paid-tag {
            color: #27ae55;
            background: rgba(39, 174, 85, 0.1);
          }
          .unpaid-tag {
            color: #f42c2c;
            background-color: #ffbdbd;
          }
        }
      }
    }
    .cancel-order {
      background: #ffbdbd;
      border-radius: 28px;
      color: #f42c2c;
      font-size: 14px;
      line-height: 17px;
      padding: 10px 20px;
      border: none;
      text-transform: capitalize;
    }
  }
  .expand-collapse-class {
    display: flex;
    border: none;
    h4 {
      background: #005586;
      padding: 0px;
      width: 17px;
      border-radius: 50%;
      height: 16px;
      margin: 5px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #ffff;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 11px 6px;
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
    }
    h5 {
      background: #005586;
      padding: 0px;
      width: 16px;
      border-radius: 50%;
      height: 16px;
      margin: 5px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #ffff;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 11px 5px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }
  }
  .order-details-wrapper {
    border: 1px solid #ececee;
    border-top: 0;
    border-bottom: 0;
    td {
      border: none;
    }
    h6 {
      font-size: 13px;
      font-weight: bold;
    }
    p {
      font-size: 14px;
      margin-top: 10px;
    }
    .print-tag-style {
      border: 1px solid #e5e5e5;
      padding: 5px 15px 5px 15px;
      border-radius: 5px;
      background: linear-gradient(90deg, #55c416 0%, #367910 100%);
      color: #fff;
    }
  }
`;
